import React, { lazy } from 'react'
import { Route } from 'react-router-dom';
import ChangePassword from '../pages/Dashboard/ChangePassword.js';
const YourTeams = lazy(() => import('../pages/Dashboard/YourTeams.js'));
const YourTeamDetails = lazy(() => import('../pages/Dashboard/YourTeamDetails.js'));
const Setting = lazy(() => import('../pages/Dashboard/Setting.js'));
const TeamRoster = lazy(() => import('../pages/Dashboard/TeamRoster.js'));
const AllTeamsDetails = lazy(() => import('../pages/Dashboard/AllTeamsDetails.js'));
const AllTeam = lazy(() => import("../pages/Dashboard/AllTeam.js"));
const PaymentHistory = lazy(() => import('../pages/Dashboard/Payment.js'));
const RegisterTeam = lazy(() => import('../pages/Payment/RegisterTeam.jsx'));
const AddRosterMember = lazy(() => import('../pages/Dashboard/AddRosterMember.js'));
const TeamStandings = lazy(() => import('../pages/Dashboard/TeamStandings.js'));

const Co_ManagerRoutes = (
    <>
        <Route exact path='/dashboard/yourteam' element={<YourTeams />}></Route>
        <Route exact path='/dashboard/yourteam/:id' element={<YourTeamDetails />}></Route>
        <Route exact path='/dashboard/user/setting' element={<Setting />}></Route>
        <Route exact path='/dashboard/user/change-password' element={<ChangePassword />}></Route>
        <Route exact path='/dashboard/team/:teamId/roster' element={<TeamRoster />}></Route>

                <Route exact path='/dashboard/allteams' element={<AllTeam />}></Route>
                <Route exact path='/dashboard/allteams/:id' element={<AllTeamsDetails />}></Route>
                <Route exact path='/dashboard/payment/history' element={<PaymentHistory />}></Route>
                <Route exact path='/dashboard/registerteam/:id' element={<RegisterTeam />}></Route>
                <Route exact path='/dashboard/team/:teamId/add-roster-member' element={<AddRosterMember />}></Route>
                <Route exact path='/dashboard/team/:teamId/standings' element={<TeamStandings />} />



    </>
)

export default Co_ManagerRoutes